import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Typography, Chip } from "@material-tailwind/react";
import { useAuth } from '../../AuthContext';
import SearchableSelect from '../../../common/SearchableSelect';

const TransactionTypeFilter = ({ selectedType, onTypeChange, className = "" }) => {
    const { rootUrl } = require('../../../../config/config');
    const { token } = useAuth();
    const [transactionTypes, setTransactionTypes] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchTransactionTypes = async () => {
            try {
                const response = await axios.get(`${rootUrl}/weekly-summary/transaction-types`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setTransactionTypes(response.data);
            } catch (error) {
                console.error('Error fetching transaction types:', error);
                // Fallback to common transaction types if API fails
                const fallbackTypes = [
                    { type: 'fuel', name: 'Fuel' },
                    { type: 'maintenance', name: 'Maintenance' },
                    { type: 'insurance', name: 'Insurance' },
                    { type: 'repair', name: 'Repair' }
                ];
                setTransactionTypes(fallbackTypes);
            } finally {
                setLoading(false);
            }
        };

        fetchTransactionTypes();
    }, [rootUrl, token]);

    const getSelectedTypeName = () => {
        if (!selectedType) return null;
        const type = transactionTypes.find(t => t.type === selectedType);
        return type ? type.name : selectedType;
    };

    const clearFilter = () => {
        onTypeChange(null);
    };

    if (loading) {
        return (
            <div className={`space-y-2 ${className}`}>
                <Typography variant="small" color="blue-gray" className="font-medium">
                    Filter by Transaction Type
                </Typography>
                <div className="animate-pulse bg-gray-200 h-10 rounded-lg"></div>
            </div>
        );
    }

    return (
        <div className={`space-y-2 ${className}`}>
            <div className="flex items-center justify-between">
                <Typography variant="small" color="blue-gray" className="font-medium">
                    Filter by Transaction Type
                </Typography>
                {selectedType && (
                    <button
                        onClick={clearFilter}
                        className="text-xs text-blue-600 hover:text-blue-800"
                    >
                        Clear
                    </button>
                )}
            </div>

            <SearchableSelect
                placeholder="All Transaction Types"
                value={selectedType}
                onChange={(value) => onTypeChange(value || null)}
                loading={loading}
                options={[
                    { value: '', label: 'All Transaction Types' },
                    ...transactionTypes.map(type => ({
                        value: type.type,
                        label: `${type.name} (${type.type})`
                    }))
                ]}
                className="bg-white"
            />

            {selectedType && (
                <Chip
                    size="sm"
                    variant="filled"
                    color="green"
                    value={`Selected: ${getSelectedTypeName()}`}
                    className="w-fit"
                    onClose={clearFilter}
                />
            )}
        </div>
    );
};

export default TransactionTypeFilter;
